import type { dashboardWidgetRegistry } from '@/components/dashboard/DashboardCanvas';
import { NetworkDemandRenderer } from './NetworkDemandRenderer';
import { NetworkMetricRenderer } from './NetworkMetricRenderer';
import { NetworkPerformanceRenderer } from './NetworkPerformanceRenderer';
import { NetworkPerformanceTablesRenderer } from './NetworkPerformanceTablesRenderer';
import { NetworkSectionHeadingRenderer } from './NetworkSectionHeadingRenderer';
import type { networkDashboardRuntime } from './widgetRuntime';
import {
  networkDemandPerformanceWidgetSchema,
  networkMetricWidgetSchema,
  networkPerformanceChartWidgetSchema,
  networkPerformanceTablesWidgetSchema,
  networkRevenueDistributionWidgetSchema,
  networkSectionHeadingWidgetSchema,
  networkWonBidsDistributionWidgetSchema,
  NetworkDashboardWidgetType,
  type NetworkDashboardWidget,
} from './widgetModel';

export const networkDashboardWidgetRegistry: dashboardWidgetRegistry<
  NetworkDashboardWidget,
  networkDashboardRuntime
> = {
  [NetworkDashboardWidgetType.SectionHeading]: {
    schema: networkSectionHeadingWidgetSchema,
    component: NetworkSectionHeadingRenderer,
  },
  [NetworkDashboardWidgetType.Metric]: {
    schema: networkMetricWidgetSchema,
    component: NetworkMetricRenderer,
    twoPerMobileRow: true,
  },
  [NetworkDashboardWidgetType.PerformanceChart]: {
    schema: networkPerformanceChartWidgetSchema,
    component: NetworkPerformanceRenderer,
  },
  [NetworkDashboardWidgetType.PerformanceTables]: {
    schema: networkPerformanceTablesWidgetSchema,
    component: NetworkPerformanceTablesRenderer,
  },
  [NetworkDashboardWidgetType.RevenueDistribution]: {
    schema: networkRevenueDistributionWidgetSchema,
    component: NetworkDemandRenderer,
  },
  [NetworkDashboardWidgetType.WonBidsDistribution]: {
    schema: networkWonBidsDistributionWidgetSchema,
    component: NetworkDemandRenderer,
  },
  [NetworkDashboardWidgetType.DemandPerformance]: {
    schema: networkDemandPerformanceWidgetSchema,
    component: NetworkDemandRenderer,
  },
};
